var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show && _setup.cssGroupNames
    ? _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-light btn-sm dropdown-toggle",
            attrs: { "data-bs-toggle": "dropdown", type: "button" },
          },
          [_vm._v("\n        " + _vm._s(_setup.activeCssGroupName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu" },
          _vm._l(_setup.groupNames, function (groupName) {
            return _c(
              "button",
              {
                key: groupName,
                staticClass: "dropdown-item",
                class: { active: groupName === _setup.activeCssGroupName },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _setup.setActiveCssGroupName(groupName)
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(groupName) + "\n        ")]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }